// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL:   "https://dharma-back-dbxy.onrender.com/",
});

export default axiosInstance;

export const weburl = "https://dharma-back-dbxy.onrender.com/";
// export const weburl = "http://localhost:3050/";

export const Homeurl = "https://fitamigo.spacedeco.in/";
export const adminurl = "https://adminfitamigo.spacedeco.in/";
export const keyLogin = '6790eedec0468755d4a7a631';
export const LiveURL = 'https://secure.payu.in/_payment';
export const TestURL = 'https://test.payu.in/_payment';

// export const weburl = 'https://backend-2o7f.onrender.com/';
